// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"fc41d616","135":"04c4086a","166":"cbb6beca","226":"ea0fbf6a","488":"9b278bd3","554":"9860aea8","590":"156358a7","610":"0e292308","620":"2b67bc9d","663":"f50ecbbe","875":"b95264fd"}[chunkId] + ".chunk.js";
};